export default __webpack_public_path__ + "static/media/litho-demo-single-project-page-05.57094bf8.jpg";